import { CouponPayment } from "@goodfill/domain-properties/src";
import React from "react";
import { formatPercentage } from "@goodfill/format-number";

export function formatCouponPayment(props: { value: CouponPayment }) {
  return formatPercentage({
    value: props.value.toNumber(),
    numDecimals: 3,
  });
}

export const CouponPaymentComponent: React.FC<{ value: CouponPayment }> = (props) => <>{formatCouponPayment(props)}</>;
